module.exports = __webpack_public_path__ + "img/pin_drop.6acb138e.svg";